/**
 * Authentication Layout Component
 * 
 * Standalone layout for authentication pages without the main app shell.
 * 
 * Features:
 * - No header, navigation, or footer
 * - Full-screen layout
 * - Theme support
 * - Accessibility compliance
 * 
 * @see .specify/memory/constitution.md
 * @see /Reference/Reference design-review/design-principles.md
 */

import React from 'react';
import { ThemeProvider } from '../contexts/ThemeContext';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps): React.ReactElement {
  return (
    <ThemeProvider>
      <div className="min-h-screen">
        {children}
      </div>
    </ThemeProvider>
  );
}

export default AuthLayout;

